import * as Sentry from "@sentry/react";
import type { ReactNode } from "react";
import { Button, ErrorState } from "@evolua/ui";

export function TelemetryErrorBoundary({ children }: { children: ReactNode }) {
  return (
    <Sentry.ErrorBoundary
      fallback={({ error, resetError }) => (
        <div className="evolua-stack evolua-stack--3">
          <ErrorState
            title="Algo deu errado na interface"
            description={
              error instanceof Error ? error.message : "Erro inesperado. Tente novamente."
            }
            onRetry={resetError}
          />
          <p className="evolua-mt">
            <Button
              type="button"
              variant="ghost"
              onClick={() => window.location.assign("/")}
            >
              Ir ao início
            </Button>
          </p>
        </div>
      )}
      showDialog={false}
    >
      {children}
    </Sentry.ErrorBoundary>
  );
}
